import React, { useEffect } from "react";
import cx from "classnames";
import { animated, useTransition } from "@react-spring/web";
import styles from "./selectStreamEntity.module.scss";
import { StreamsBrowser } from "./browser";

import { Stream } from "src/types/streams";
import { useStreamsAdoption } from "src/redux/actions/adoption/streams";

interface AddAssetsFromHubProps {
  style: any;
  width: number;
  // eslint-disable-next-line no-unused-vars
  onSelection: (entity: any) => void;
  moveTo?: Stream;
  copyTo?: Stream[];
}

const SelectStreamEntity: React.FC<AddAssetsFromHubProps> = ({
  style,
  width,
  onSelection,
  moveTo,
  copyTo
}) => {
  const { trackStreamSelectionViewed } = useStreamsAdoption();

  const [query, setQuery] = React.useState<string | null>("");

  const browserTransition = useTransition(!query, {
    initial: { opacity: 1 },
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  useEffect(() => {
    trackStreamSelectionViewed();
  }, []);

  return (
    <animated.div className={cx(styles.hubAssets)} style={style}>
      <div className={cx(styles.stacks, styles.content)}>
        {browserTransition(
          (style, item) =>
            item && (
              <AssetBrowser
                style={style}
                width={width}
                onSelection={onSelection}
                moveTo={moveTo}
                copyTo={copyTo}
              />
            ),
        )}
      </div>
    </animated.div>
  );
};

interface AssetBrowserProps {
  style: any;
  width: number;
  // eslint-disable-next-line no-unused-vars
  onSelection: (entity: any) => void;
  moveTo?: Stream;
  copyTo?: any[];
}

const AssetBrowser: React.FC<AssetBrowserProps> = ({
  style,
  width,
  onSelection,
  moveTo,
  copyTo
}) => {
  const handleSelection = (entity) => {
    onSelection(entity);
  };

  return (
    <animated.div
      style={style}
      className={cx(styles.assetBrowser, styles.stack)}
    >
      <div className={styles.stacks} style={{ width: width }}>
        <StreamsBrowser
          width={width}
          onSelection={handleSelection}
          moveTo={moveTo}
          copyTo={copyTo}
        />
      </div>
    </animated.div>
  );
};

export { SelectStreamEntity };
